module.exports = __webpack_public_path__ + "img/code.693a271d.svg";